"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _FeedbackReceiveStore = _interopRequireDefault(require("./FeedbackReceiveStore2"));

var FeedbackReceiveActions = /*#__PURE__*/function () {
  function FeedbackReceiveActions() {
    (0, _classCallCheck2["default"])(this, FeedbackReceiveActions);
  }

  (0, _createClass2["default"])(FeedbackReceiveActions, null, [{
    key: "receiveChangesCompleted",
    value: function receiveChangesCompleted(message) {
      _FeedbackReceiveStore["default"].receiveChangesCompleted(message);
    }
  }, {
    key: "receiveChangesFailed",
    value: function receiveChangesFailed(message) {
      _FeedbackReceiveStore["default"].receiveChangesFailed(message);
    }
  }]);
  return FeedbackReceiveActions;
}();

var _default = FeedbackReceiveActions;
exports["default"] = _default;